import { Card, ComponentState, Skeleton } from "components/common"
import { numberConvertor, numberFormat } from "utils"

import { BarChart } from "components/charts"
import { StatsHeading } from "features/reports/components"
import { t } from "i18next"

export default function KPIBarChart(props) {
  const {
    queryObj,
    loadType,
    dataObject,
    xField,
    yField,
    title,
    extraTitle,
    useQuery,
    isStacked = true,
    className,
    showTotalKey = true,
    withMainTitleCount = true,
    mainTitleValueIdentifier = "total",
    subTitleValueIdentifier = "avgPerDay",
    extraValueWithPercentSign = false,
  } = props
  const updatedQueryObj = { ...queryObj, load: loadType }
  const { data, isFetching, error, refetch } = useQuery(updatedQueryObj, {
    refetchOnMountOrArgChange: true,
  })
  const addTotalKey = items => {
    let obj = { ...items[0], name: t("Total"), value: items[0]?.data?.total, color: "#A7A7A7" }
    return [...items, obj]
  }
  return !!error ? (
    <Card>
      <ComponentState
        description={error.message}
        status={error.status}
        btnLoading={isFetching}
        onClick={() => refetch()}
      />
    </Card>
  ) : (
    <Card
      className={className}
      title={
        isFetching ? (
          <Skeleton />
        ) : (
          <StatsHeading
            title={title}
            value={data?.[loadType]?.[mainTitleValueIdentifier]}
            showValue={withMainTitleCount}
          />
        )
      }
      extra={
        extraTitle ? (
          isFetching ? (
            <Skeleton />
          ) : (
            <StatsHeading
              type="extra"
              title={extraTitle}
              value={data?.[loadType]?.[subTitleValueIdentifier]}
              percentage={extraValueWithPercentSign && "%"}
            />
          )
        ) : null
      }
      headStyle={{ borderBottom: 0 }}
      bodyStyle={{ direction: "ltr" }}
    >
      <BarChart
        data={data?.[dataObject] ? data[dataObject] : []}
        xField={xField}
        yField={yField}
        seriesField="type"
        maxColumnWidth={20}
        colorField="type"
        color={({ type }) => (type === "Repeat" ? "#839FF4" : "#3F65DB")}
        yAxis={{ label: { formatter: v => numberConvertor(v, "intl", 2) } }}
        tooltip={{
          customItems: originalItems => {
            return showTotalKey ? addTotalKey(originalItems) : originalItems
          },
          formatter: datum => {
            const convertedValue = numberFormat(datum[yField], "en-US", 2)
            return { name: datum.type, value: convertedValue }
          },
        }}
        legend={{ marker: { symbol: "circle", style: { width: 12 } }, position: "bottom" }}
        loading={isFetching}
        disabled={isFetching}
        height={320}
        isStacked={isStacked}
      />
    </Card>
  )
}
